import React, { useState } from 'react';
import { Home, MessageSquare, ClipboardCheck, Search } from 'lucide-react';
import { VesselMindProvider, useVesselMind } from './context/VesselMindContext';
import VesselMindChat from './components/VesselMindChat';
import KnowledgeReviewPanel from './components/KnowledgeReviewPanel';
import ScenarioAnalysis from './components/ScenarioAnalysis';
import PrivacyNotice from './components/PrivacyNotice';
import PVSPageLayout from '../components/PVSPageLayout';

const VesselMindContent = () => {
  const { isAdmin, userRole } = useVesselMind();
  const [activeView, setActiveView] = useState('chat');
  const showNavTabs = isAdmin || userRole === 'readonly';

  return (
    <>
      {showNavTabs && (
        <div className="pvs-glass border-t border-pvs-border">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex gap-1">
              <button
                onClick={() => setActiveView('chat')}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-all duration-200 border-b-2 ${
                  activeView === 'chat'
                    ? 'text-white border-pvs-accent'
                    : 'text-pvs-text-muted border-transparent hover:text-white hover:border-pvs-accent/30'
                }`}
              >
                <MessageSquare className="w-4 h-4" />
                Chat
              </button>
              <button
                onClick={() => setActiveView('scenario')}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-all duration-200 border-b-2 ${
                  activeView === 'scenario'
                    ? 'text-white border-pvs-accent'
                    : 'text-pvs-text-muted border-transparent hover:text-white hover:border-pvs-accent/30'
                }`}
              >
                <Search className="w-4 h-4" />
                Scenario Analysis
              </button>
              {isAdmin && (
                <button
                  onClick={() => setActiveView('review')}
                  className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-all duration-200 border-b-2 ${
                    activeView === 'review'
                      ? 'text-white border-pvs-accent'
                      : 'text-pvs-text-muted border-transparent hover:text-white hover:border-pvs-accent/30'
                  }`}
                >
                  <ClipboardCheck className="w-4 h-4" />
                  Knowledge Review
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 py-8">
        {activeView === 'chat' && <VesselMindChat />}
        {activeView === 'scenario' && <ScenarioAnalysis />}
        {activeView === 'review' && isAdmin && <KnowledgeReviewPanel />}
      </div>
    </>
  );
};

const VesselMindPage = ({ onReturnHome }) => {
  return (
    <PVSPageLayout>
      <VesselMindProvider>
        <div className="pvs-glass border-b border-pvs-accent/20 shadow-pvs-glow">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-pvs-accent/10 border border-pvs-accent/30 rounded-lg flex items-center justify-center">
                  <span className="text-2xl">🤖</span>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-white">VesselMind</h1>
                  <p className="text-sm text-pvs-text-muted">Regulatory Decision Support for Codes of Practice</p>
                </div>
              </div>
              
              <button
                onClick={onReturnHome}
                className="flex items-center justify-center w-12 h-12 pvs-glass pvs-glass-hover"
                title="Return to Homepage"
              >
                <Home className="w-6 h-6" stroke="url(#icon-two-tone)" />
              </button>
            </div>
          </div>
        </div>

        <PrivacyNotice />
        <VesselMindContent />
      </VesselMindProvider>
    </PVSPageLayout>
  );
};

export default VesselMindPage;

